/* eslint-disable no-unused-vars */
import { useState, useEffect } from 'react';
import "./App.css";
import ScanDevicesButton from "./components/Buttons/ScanDevicesButton";
import ScanDeviceList from "./containers/ScanDevices/ScanDeviceList";
import Device from "./containers/Device";
import Intro from "./containers/Intro/Intro";
import useBleExtensionClient from "./hooks/useBleExtensionClient";
import useDeviceScanner from "./containers/ScanDevices/hooks/useDeviceScanner";
import useDeviceSelector from "./containers/ScanDevices/hooks/useDeviceSelector";
import { ModalProvider } from './components/Modal/ModalProvider';
import IntroSplash from './containers/Intro/IntroSplash';

function App() {
    const { isIntroEnabled } = useBleExtensionClient();
    const { devices, startScan, stopScan, scanning, getConnectedDevices, centralStateStatus} = useDeviceScanner();
    const { selectedDevice, onDeviceSelected, onDeviceUnselected, onDeviceConnected } = useDeviceSelector();
    const [showSplash, setShowSplash] = useState(true);

    useEffect(() => {
        if (selectedDevice?.id) {
            stopScan();
        }
    }, [selectedDevice]);

    useEffect(() => {
        startScan();
        const timer = setTimeout(() => {
            stopScan();
            setShowSplash(false);
        }, 2000); 

        return () => clearTimeout(timer);
    }, []);


    if (showSplash) {
        return <IntroSplash />; 
    }

    if (isIntroEnabled) {
        return <Intro id={selectedDevice?.id}/>
    }

    

    return (
        <>
            <ModalProvider>

                {selectedDevice?.id ? (
                    <Device
                        id={selectedDevice.id}
                        name={selectedDevice?.name}
                        onDeviceUnselected={onDeviceUnselected}
                    />
                ) : (
                    <div className="flex flex-col gap-2 h-full justify-between flex-1 relative">
                        <ScanDeviceList
                            devices={devices}
                            onDeviceSelected={onDeviceSelected}
                            onDeviceConnected={onDeviceConnected}
                            onDeviceUnselected={onDeviceUnselected}
                            centralStateStatus={centralStateStatus}
                        />
                        <div className="w-full p-4">
                            <ScanDevicesButton
                                loading={scanning}
                                startScan={startScan}
                                stopScan={stopScan}
                            />
                        </div>
                    </div>
                )}

            </ModalProvider>

        </>
    )
}

export default App;
